// This example shows you how to set up React Stripe.js and use Elements.
// Learn how to accept a payment using the official Stripe docs.
// https://www.stripe.com/docs/payments/integration-builder

import React, { useEffect, useState } from "react";

import "../css/global.css";

import check from "../assets/check.png";
import error from "../assets/error.png";

const popupContent = {
  ok: {
    img: check,
    title: "Φοβερό!",
    text: "Το email σας έχει σταλεί.",
  },
  error: {
    img: error,
    title: "Ωχ...",
    text: "Αυτό το email υπάρχει ήδη.",
  },
};

const wrongEmail = "Εισαγάγετε μια έγκυρη διεύθυνση email.";

const emailRegex = /\S+@\S+\.\S+/;

const Discount = () => {
  const [email, setEmail] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [popupData, setPopupData] = useState(null);
  const [isShowErrors, setIsShowErrors] = useState(null);

  useEffect(() => {
    if (isShowErrors) {
      setIsShowErrors(false);
    }
  }, [email]);

  const onSubmit = (e) => {
    e.preventDefault();

    if (!email || !emailRegex.test(email)) {
      return setIsShowErrors(true);
    }

    setIsLoading(true);

    fetch("discountstarif.php", {
      method: "POST",
      mode: "cors",
      cache: "no-cache",
      headers: {
        "Content-Type": "application/json",
      },
      referrerPolicy: "no-referrer",
      body: JSON.stringify({ email }),
    })
      .then((response) => {
        return response.json();
      })
      .then((res) => {
        setTimeout(() => setPopupData(null), 3000);

        if (res === "ok") {
          return setPopupData(popupContent.ok);
        }

        setPopupData(popupContent.error);
      })
      .finally(setIsLoading(false));
  };

  return (
    <>
      <div className="discountWrapper">
        <h2 className="modalTitle">Λάβετε έκπτωση 10%</h2>
        <span className="discountDescription">
          Μπορείτε να αφήσετε το email σας για να λάβετε έκπτωση 10% όταν
          αγοράζετε μια συνδρομή
        </span>
        <form onSubmit={onSubmit}>
          <p className="marginLeft">
            <label className="formLabel">E-mail</label>
            <input
              className={`formInput ${isShowErrors ? "error" : ""}`}
              type="text"
              name="email"
              value={email}
              onChange={({ target: { value } }) => setEmail(value)}
            />
            {isShowErrors && <span className="errorText">{wrongEmail}</span>}
          </p>
          <p>
            <input
              disabled={isLoading}
              className="greenButton"
              type="submit"
              value="Πάρτε το"
            />
          </p>
        </form>
      </div>

      {popupData && (
        <div id="myModal" className="modal">
          <div className="modal-content">
            <span className="close" onClick={() => setPopupData(null)}>
              &times;
            </span>
            <img className="checkIcon" src={popupData.img} alt="check-icon" />
            <span className="modalText">{popupData.title}</span>
            <span className="modalText">{popupData.text}</span>
          </div>
        </div>
      )}
    </>
  );
};

export default Discount;
